export default "__VITE_ASSET__C3NYb7u$__"